var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingplanMiddleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 59,
    viewBox: "0 0 31 59",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_241_709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2983 59L30.2983 3.89516L26.7946 0.396556L3.76588 0.396552L0.298349 3.89515L0.298342 59L30.2983 59Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2483 58.95L30.2483 3.91589L26.7739 0.446557L3.78672 0.446553L0.348349 3.91573L0.348342 58.95L30.2483 58.95Z",
    stroke: "url(#paint0_linear_241_709)",
    strokeOpacity: 0.5,
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2483 58.95L30.2483 3.91589L26.7739 0.446557L3.78672 0.446553L0.348349 3.91573L0.348342 58.95L30.2483 58.95Z",
    stroke: "url(#paint1_linear_241_709)",
    strokeOpacity: 0.5,
    strokeWidth: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_241_709",
    x: -14.7017,
    y: -14.6035,
    width: 60,
    height: 88.6035,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_241_709"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_241_709",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_241_709",
    x1: -0.333981,
    y1: 44.581,
    x2: 23.2177,
    y2: 36.925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_241_709",
    x1: 32.5203,
    y1: -9.06125,
    x2: 21.0152,
    y2: -6.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingplanMiddleBackground);
export default __webpack_public_path__ + "static/media/pricingplanMiddleBackground.e58a8c4db4c126a04cbee2699639fa31.svg";
export { ForwardRef as ReactComponent };